import React, { useEffect, useState, useMemo, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import DataCuenta from "./DataCuenta";
 
import apiInstance from "../../../services/ServiceApi";
import { externalHangup, externalStatus } from "../../../utilities/vicidial/save";
import TipificacionEasy from "../TipificacionEasy";
import { useTime } from "../../../context/tmo";
import SaveForm from "./SaveForm";
import AlertModal from "../../utilities/AlertModal";

const Cuentas = ({
  identificador,
  id_linea_negocio,
  id_cartera,
  codigo_llamada,
  numero_contactado,
  codigo_usuario,
  campaign,
  idCliente 
}) => {
  console.log("componente cuentas")
  const theme = useTheme();
  const tiempoTranscurrido = useTime();
  const [rowSelectionMotivo, setRowSelectionsMotivo] = useState([]);
  const [agendaDateTime, setAgendaDateTime] = useState(null);
  const [observacion, setObservation] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [fechasPromesa, setFechasPromesa] = useState({});
  const [isVenta, setIsVenta] = useState(false);
  const [montosPromesa, setMontosPromesa] = useState({});
  const [dataTipificaciones, setDataTipificaciones] = useState(null);
  const [dataMotivos, setDataMotivos] = useState([]);
  const [errorTipificaciones, setErrorTipificaciones] = useState(null);
  const [formValues, setFormValues] = useState(null);
  const [dataCuentas, setDataCuentas] = useState(null);
  const [loadingCuentas, setLoadingCuentas] = useState(false);
  const [isAgenda, setIsAgenda] = useState(false);
  const [errorCuentas, setErrorCuentas] = useState(null);
  const [selectedValues, setSelectedValues] = useState([]);
  const [allSelected, setAllSelected] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const handleCloseModalAlert = () => { setModalOpen(false); };
  const [modalMensaje, setModalMensaje] = useState(null);
  const [seleccionesPrincipales, setSeleccionesPrincipales] = useState([]);
  const [tratamientoDatos, setTratamientoDatos] = useState("");

  const dataCuentasMemo = useMemo(() => dataCuentas || [], [dataCuentas]);
  const dataTipificacionesMemo = useMemo(() => dataTipificaciones || {}, [dataTipificaciones]);
  const handleSelectsChange = useCallback((newSelects) => {
    const allSelected = newSelects.every((select) => select.selected !== "");
    setAllSelected(allSelected);

  }, []);
  useEffect(() => {
    if (!identificador || !id_linea_negocio) return;

    setLoadingCuentas(true);
    apiInstance
      .get("clienteDetalle", {
        params: { identificador, id_linea_negocio },
      })
      .then((response) => {
        console.log("data cuentas ", response.data);
        setDataCuentas(response.data);
        setLoadingCuentas(false);
      })
      .catch((error) => {
        setErrorCuentas(error);
        setLoadingCuentas(false);
      });
  }, [identificador, id_linea_negocio, apiInstance]);

  useEffect(() => {
    if (!identificador) {
      setModalOpen(true);
      setModalMensaje("La propiedad 'identificador' es obligatoria.");
    } else if (!codigo_llamada) {
      setModalOpen(true);
      setModalMensaje("La propiedad 'codigo llamada' es obligatoria.");
    }
  }, [identificador, codigo_llamada]);

  useEffect(() => {
    const fetchTipificaciones = async () => {
      try {
        if (id_linea_negocio) {
          const response = await apiInstance.get("tipificaciones", {
            params: { linea_negocio: id_linea_negocio, id_cartera: id_cartera },
          });
          if (response.data.motivo) {
            setDataMotivos(response.data.motivo);
          }
          setDataTipificaciones(response.data);
        }
      } catch (error) {
        console.log(error);
        setErrorTipificaciones(error);
      }
    };

    fetchTipificaciones();
  }, [apiInstance, id_linea_negocio]);

  if (loadingCuentas) {
    return <CircularProgress />;
  }

  if (errorCuentas || errorTipificaciones) {
    return <Alert severity="error">Error al cargar los datos</Alert>;
  }

  if (!dataTipificaciones) {
    return <Alert severity="error">No se encontraron Tipificaciones</Alert>;
  }

  if (!dataCuentas || !dataTipificaciones) {
    return (
      <Alert severity="error">
        No se encontraron cuentas activas para este cliente
      </Alert>
    );
  }
  const handleSelectChange = (selectedOption) => {
    if (!selectedOption) return;
    setSelectedValues((values) => {
      const updatedValues = values.filter((value) => value.id !== selectedOption.id);
      const newSelectedValue = {
        id: selectedOption.id,
        venta: selectedOption.venta,
        codigo_discador: selectedOption.codigo_discador,
        tipificacion: selectedOption.tipificacion,
        label: selectedOption.label,
        orden: selectedOption.orden,
        peso:selectedOption.peso,
      };

      updatedValues.push(newSelectedValue);
      setSeleccionesPrincipales(updatedValues);

      return updatedValues;
    });
  };
  const handleSave = async () => {
    if (isAgenda === true && agendaDateTime === null) {
      setModalOpen(true);
      setModalMensaje("Es necesario que ingresa una Agendamiento");
      return;
    }
    if (isVenta === true && formValues === null) {
      setModalOpen(true);
      setModalMensaje("Debe completar la Ficha de Venta");
      return;
    }
    if (!allSelected) {
      setModalOpen(true);
      setModalMensaje("Debe seleccionar todas las tipificaciones");
      return;
    }
    dataCuentas.map((cuentaData, index) => {
      const tipificationData = selectedValues[index] || [];
      const idCuenta = cuentaData.id;
      let fechaPromesa = fechasPromesa[idCuenta];
      let montoPromesa = montosPromesa[idCuenta];
      let motivo = rowSelectionMotivo[idCuenta];
      const tipificacion = {
        cuenta:cuentaData,
        tipificacion:selectedValues,
        venta:[],
        cliente_id: idCliente,
        identificador:identificador,
        id_linea_negocio:id_linea_negocio,
        codigo_llamada:codigo_llamada,
        numero_contactado:numero_contactado,
        codigo_usuario:codigo_usuario,
        campaign:campaign,
        observacion:observacion,
        agendaDateTime:agendaDateTime,
        tmo:tiempoTranscurrido,
        tratamiento_datos: tratamientoDatos

      };
 
      try {
        setIsLoading(true);
        setIsSaving(true)
        apiInstance.post("saveGestion/", tipificacion);
        setModalOpen(true);
        setModalMensaje("Se guardaron los registros");
      } catch (error) {
        setModalOpen(true);
        setModalMensaje("Hubo un error al intentar guardar los registros: " + JSON.stringify(error)); // Mostrar el error como cadena de texto
        return false;
      }
    });
    try {
      externalHangup({ agentId: codigo_usuario, value: 1 });
      externalStatus({ agentId: codigo_usuario, value: 1 });
    } catch (error) {
      console.error("Error general", error);
      return false;
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <AlertModal
        open={modalOpen}
        onClose={handleCloseModalAlert}
        message={modalMensaje}
      />
      <DataCuenta dataCuentas={dataCuentasMemo}  id_linea_negocio={id_linea_negocio}/>
      <Paper sx={{ mb: 2 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Tipificación General de Cuentas
        </Typography>
      </Paper>
      <TableContainer
        component={Paper}
        sx={{ maxWidth: "100%", margin: "auto" }}
        mb={4}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.common.white,
                }}
              >
                ID Cuenta
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.common.white,
                }}
              >
                TIPIFICAR
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataCuentasMemo.map((item, index) => (
              <TableRow
                key={index}
                hover
                sx={{
                  "&:hover": { backgroundColor: theme.palette.action.hover },
                  "& td": {
                    border: "1px solid rgba(224, 224, 224, 1)",
                    padding: theme.spacing(1),
                  },
                }}
              >
                <TableCell>{item.id}</TableCell>
                <TableCell>
                  <TipificacionEasy
                    data={dataTipificacionesMemo}
                    onChange={handleSelectChange}
                    onSelectsChange={handleSelectsChange}
                    seleccionesIniciales={selectedValues[index] || seleccionesPrincipales}

                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <SaveForm
              agendaDateTime={agendaDateTime}
              setAgendaDateTime={setAgendaDateTime}
              observacion={observacion}
              setObservation={setObservation}
              handleSave={handleSave}
              isSaving={isSaving}
              theme={theme}
            />
        {id_linea_negocio.id ===5 && 
        <Grid item xs={12} >
        <FormControl  style={{ minWidth: 200 }}>
                <InputLabel>Acepta Tratamiento de datos</InputLabel>
                  <Select
                    value={tratamientoDatos}
                    onChange={e =>setTratamientoDatos(e.target.value)}
                    label="Acepta Tratamiento de datos"
                  >
                    <MenuItem  value={""}>SELECCIONE</MenuItem>
                    <MenuItem  value={"SI"}>SI</MenuItem>
                    <MenuItem  value={"NO"}>NO</MenuItem>
                </Select>
              </FormControl>
      </Grid>


        }
    </>
  );
};

export default Cuentas;